import {
	queryOptions,
	useQuery,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { portalApi } from "@services/api/portalApi";
import type { StaffMe } from "./types";
import { useStaffOverrideStore } from "@stores/useStaffOverrideStore";
import { PortalMode, usePortalModeStore } from "@stores/usePortalModeStore";

export type MeIdentity = {
	type: "staff" | "student" | "parent";
	username: string | null;
	displayName: string | null;
	objectId: string | null;
};
export type MeSession = {
	actual: MeIdentity;
	effective: MeIdentity;
	hostMode: "staff" | "student" | "parent";
	viewMode: "staff" | "student" | "parent";
	impersonating: boolean;
	permissions: string[];
	actualStaffProfile: StaffMe | null;
	effectiveStaffProfile: StaffMe | null;
};

export function getEffectiveUsernameOverride() {
	return useStaffOverrideStore.getState().override?.trim() || null;
}

export const meSessionQueryOptions = (
	usernameOverride = getEffectiveUsernameOverride(),
	viewMode: PortalMode = usePortalModeStore.getState().viewMode,
) =>
	queryOptions({
		queryKey: ["me-session", viewMode, usernameOverride],
		queryFn: async () => (await portalApi.get<MeSession>("/me")).data,
	});

export function useMeSession() {
	const usernameOverride = useStaffOverrideStore(
		(state) => state.override?.trim() || null,
	);
	const viewMode = usePortalModeStore((state) => state.viewMode);
	return useQuery(meSessionQueryOptions(usernameOverride, viewMode));
}
export function useMeSessionSuspense() {
	const usernameOverride = useStaffOverrideStore(
		(state) => state.override?.trim() || null,
	);
	const viewMode = usePortalModeStore((state) => state.viewMode);
	return useSuspenseQuery(meSessionQueryOptions(usernameOverride, viewMode));
}
